import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import moment from "moment";
import { auth, db } from "../firebase";
import {
    collection,
    query,
    where,
    onSnapshot,
    getDoc,
    doc,
} from "firebase/firestore";
import { useReactToPrint } from "react-to-print";

import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
} from "@mui/material";
import { Timestamp } from "firebase/firestore";

export default function Productwise() {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
    });

    const printRef = useRef();

    /* ================= STATE ================= */
    const [propertyId, setPropertyId] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [reportData, setReportData] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);

    /* ================= DEFAULT DATE ================= */
    useEffect(() => {
        setFromDate(moment().format("YYYY-MM-DD"));
    }, []);

    /* ================= AUTH → PROPERTY ================= */
    useEffect(() => {
        const unsub = auth.onAuthStateChanged(async (user) => {
            if (!user) return;

            const snap = await getDoc(doc(db, "authroles", user.uid));
            if (snap.exists()) {
                setPropertyId(snap.data().propertyId);
            }
        });

        return () => unsub();
    }, []);


    const getReport = () => {
        if (!propertyId || !fromDate) return;

        setReportData([]);
        setTotalAmount(0);

        // 🔹 Start & End of selected day
        const start = new Date(fromDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(fromDate);
        end.setHours(23, 59, 59, 999);

        const q = query(
            collection(db, "orderitems"),
            where("propertyId", "==", propertyId),
            where("createdAt", ">=", Timestamp.fromDate(start)),
            where("createdAt", "<=", Timestamp.fromDate(end))
        );

        onSnapshot(q, (snap) => {
            const productMap = new Map();
            let grandTotal = 0;

            snap.forEach((d) => {
                const data = d.data();

                const key = data.name;
                const qty = Number(data.qty || 0);
                const rate = Number(data.rate || 0);
                const total = qty * rate;

                if (!productMap.has(key)) {
                    productMap.set(key, {
                        itemname: data.name,
                        rate,
                        quantity: qty,
                        total,
                    });
                } else {
                    const p = productMap.get(key);
                    p.quantity += qty;
                    p.total += total;
                }

                grandTotal += total;
            });

            const rows = Array.from(productMap.values()).sort((a, b) =>
                a.itemname.localeCompare(b.itemname)
            );

            console.log(rows);
            setReportData(rows);
            setTotalAmount(grandTotal.toFixed(2));
        });
    };

    /* ================= PRINT ================= */
    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    /* ================= UI ================= */
    return (
        <Box className=" p-3">
            <Card>
                <CardContent>
                    <Typography variant="h5" fontWeight="bold" mb={2}>
                        Product Wise Report
                    </Typography>

                    {/* FILTER */}
                    <Grid container spacing={2} mb={2}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                type="date"
                                label="Date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>

                        <Grid item xs={12} md={3} alignSelf="center">
                            <Button
                                variant="contained"
                                fullWidth
                                onClick={getReport}
                            >
                                Get Report
                            </Button>
                        </Grid>
                    </Grid>

                    {/* REPORT */}
                    <TableContainer component={Paper} ref={printRef}>
                       
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {[
                                        "#",
                                        "Date",
                                        "Product Name",
                                        "Rate",
                                        "Quantity",
                                        "Total",
                                    ].map((h) => (
                                        <TableCell key={h} sx={{ fontWeight: "bold" }}>
                                            {h}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {reportData.map((r, i) => (
                                    <TableRow key={i}>
                                        <TableCell>{i + 1}</TableCell>
                                        <TableCell>
                                            {moment(fromDate).format("DD-MM-YYYY")}
                                        </TableCell>
                                        <TableCell>{r.itemname}</TableCell>
                                        <TableCell>{r.rate}</TableCell>
                                        <TableCell>{r.quantity}</TableCell>
                                        <TableCell>{r.total.toFixed(2)}</TableCell>
                                    </TableRow>
                                ))}

                                {/* TOTAL */}
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        <b>Total</b>
                                    </TableCell>
                                    <TableCell>
                                        <b>{totalAmount}</b>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box textAlign="center" mt={2}>
                        <Button variant="outlined" onClick={handlePrint}>
                            Print Report
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </Box>
    );
}
